import { useTranslations } from "next-intl";
import { cn } from "@ui/lib/utils";
import * as m from "motion/react-m";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import IconCall from "@ui/central-icons/icons/IconCall";
import IconCallCancelFilled from "@ui/central-icons/icons/IconCallCancelFilled";
import IconLoader from "@ui/central-icons/icons/IconLoader";
import IconStop from "@ui/central-icons/icons/IconStop";

export function AgentCallButton({
  sessionIsActive,
  isLoading = false,
  isTextMode,
  onToggle,
  className,
}: {
  sessionIsActive: boolean;
  isLoading?: boolean;
  isTextMode?: boolean;
  onToggle: () => void;
  className?: string;
}) {
  const t = useTranslations("ClientKeys.ConvAI");

  const showStopIcon = sessionIsActive && isTextMode;

  return (
    <m.button
      layout
      type='button'
      className={cn(
        "tw-bg-white tw-text-black tw-rounded-full tw-size-12 tw-flex tw-items-center tw-justify-center tw-outline-none focus-visible:tw-outline-focus",
        className,
      )}
      style={{ boxShadow: "0 0 1px 0 rgb(0 0 0 / 0.4), 0 4px 4px rgb(0 0 0 / 0.04)" }}
      aria-label={
        isLoading ? t("start_call") : sessionIsActive ? (showStopIcon ? t("stop") : t("end_call")) : t("start_call")
      }
      aria-busy={isLoading}
      onClick={onToggle}
    >
      {isLoading ? (
        <IconLoader className={cn(iconStrokeFix, "tw-size-5 tw-animate-spin")} />
      ) : showStopIcon ? (
        <IconStop className='tw-size-6 tw-fill-current [&>path]:tw-stroke-0' />
      ) : sessionIsActive ? (
        <IconCallCancelFilled className={cn(iconStrokeFix, "tw-size-6")} />
      ) : (
        <IconCall className='tw-size-6 tw-fill-current [&>path]:tw-stroke-0' />
      )}
    </m.button>
  );
}
